var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.25L11.25 15.5L15 10.25M12 3.21399C9.73574 5.36422 6.72026 6.54357 3.598 6.49999C3.20084 7.70997 2.99898 8.97549 3 10.249C3 15.841 6.824 20.539 12 21.872C17.176 20.54 21 15.842 21 10.25C21 8.93999 20.79 7.67899 20.402 6.49899H20.25C17.054 6.49899 14.15 5.25099 12 3.21399Z",
    stroke: "#007FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueShield);
export default __webpack_public_path__ + "static/media/blue-shield.41e3bb563fedda129f2929fd5c5e11eb.svg";
export { ForwardRef as ReactComponent };